import axios from "axios";

// const BASE_URL = "https://derbyb.ritaz.in/api";
const BASE_URL = "http://localhost:8500/api";
const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor for adding tokens if needed
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("authToken"); // Get token if stored
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;